import lookups from "./lookups";
import { PastYearsSelectHeader } from "../components/elements/DateSelectHeader";
import { OnHoldReasonFormStages } from "./onHoldReason";

export const OnHoldReasonsFormStages = [
  {
    title: "On Hold Reasons",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowEdit: true,
          allowStatusEdit: true,
          fields: [
            {
              name: "g4b_allowaccess",
              className: "col-bool",
            },
            {
              name: "g4b_allowpurchase",
              className: "col-bool",
            },
            {
              name: "g4b_allowticketallocation",
              className: "col-bool",
            },
            {
              name: "g4b_reasoncode",
              className: "col-short-name",
            },
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              textFieldsSearch: ["Name"],
              type: "text",
            },
            {
              name: "createdon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
            {
              name: "modifiedon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
          ],
          linkForNewRecord: "/on-hold-reason",
          lookup: lookups.g4b_onholdreason.all,
          subFormStages: OnHoldReasonFormStages,
          useAlphabetPagination: true,
          useSubForm: false,
        },
      },
    ],
  },
];
